<template>
<div class="chapter">
<div class="inner_page">
      ﻿


<title>Smoke and Mirrors</title>
<link href="../styles/styles.css" rel="stylesheet" type="text/css"/>
<link href="../styles/additional.css" rel="stylesheet" type="text/css"/>
<h1 class="book-title1">SMOKE AND MIRRORS</h1>
<h2 class="book-subtitle"><span class="small"><em>A Miss Barnum Mystery</em></span></h2>
<p> </p>
<p> </p>
<h2 class="book-author">Casey Daniels</h2>
<p> </p>
<p> </p>
<p> </p>
<p> </p>
<p> </p>
<p class="publisher-logo"><img alt="logo missing" height="47" src="images/logo.jpg" width="65"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title.vue?cdc0c712